import React from 'react';
import heroImage from '../../../assets/images/about_screen/community_impact_screen/impact_hero.jpg';

const HeroSection = () => {
  return (
    <div
      className="w-full h-[350px] md:h-[550px] 2xl:h-[600px] 4xl:h-[750px] 5xl:h-[850px] 3xl:h-[700px] bg-cover bg-center relative z-20"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className="absolute top-0 left-0 w-full bg-headerBg/90 px-4 py-2 xs:py-4 xs:pb-4 sm:pb-1">
        <div className="flex items-start md:items-center flex-col md:flex-row md:gap-10 justify-normal md:justify-between  max-w-[1200px] mx-auto">
          <p className="text-white text-[20px] md:text-[28px] lg:text-[38px] 2xl:text-[40px] 3xl:text-[53px] font-[700] tracking-wide">
            Community Impact
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
